@if (gameLoaded) {
<div class="jeopardy-select-topic-grid">
  <div class="user">
    <img [src]="currentUser.avatar" [alt]="i18n.str('challengeu.avatar_picture', 'Your avatar picture')()" />
    <p class="name">{{currentUser.username}}</p>
    <p class="score">{{score}} {{i18n.str('challengeu.question_points', 'points')()}}</p>
  </div>
  <div class="rounds-progress">
    <div class="progress">
      <div class="progress-container">
        <div class="rounds desktop-only">
          <a class="arrow left" [class.disabled]="roundIndex === 0" href="#" (click)="scrollLeft($event)"
             title="Click to shift the list of progress steps to the left"></a>
          <div class="rounds-container">
            <div #roundsContainer class="content" [style.width]="progressWidth + 'em'" [style.transform]="translateX">
              @for (round of gameRounds(); track round; let i = $index; let last = $last) {
              <div class="round" [class.wrong]="round.wrongAnswer" [class.success]="round.correctAnswer"
                   [class.active]="round.active" [class.skipped]="round.answerSkipped"
                   [class.noAnswerSelected]="round.noAnswerSelected">
                @if (round.correctAnswer) {
                <i class="fa fa-grin"></i>
                }
                @if (round.wrongAnswer || round.noAnswerSelected) {
                <i class="fa fa-frown"></i>
                }
                @if (round.answerSkipped) {
                <i class="fa fa-step-forward"></i>
                }
                @if (!round.hasAnswer) {
                <span>{{round.roundNumber}}</span>
                }
              </div>
              @if (!last) {
              <div class="round-spacer finished"></div>
              }
              }
            </div>
          </div>
          <a class="arrow right" [class.disabled]="roundIndex === roundsNumber() - 1" href="#"
             (click)="scrollRight($event)"></a>
        </div>
        @if (gameRounds().length) {
        <div class="rounds mobile-only">
          <div>
            <a class="arrow left" [class.disabled]="roundIndex === 0 || isWheelSpinning" href="#"
               (click)="scrollLeftMobile($event)" title="Click to shift the list of progress steps to the left"></a>
          </div>
          <div class="rounds-mobile">
            <div class="content" style="padding-left: 2em;padding-right: 2em;">
              <div class="round" [class.wrong]="gameRounds()[roundIndex]?.wrongAnswer"
                   [class.success]="gameRounds()[roundIndex]?.correctAnswer"
                   [class.active]="gameRounds()[roundIndex]?.active"
                   [class.skipped]="gameRounds()[roundIndex]?.answerSkipped"
                   [class.noAnswerSelected]="gameRounds()[roundIndex]?.noAnswerSelected">
                @if (gameRounds()[roundIndex]?.correctAnswer) {
                <i class="fa fa-grin"></i>
                }
                @if (gameRounds()[roundIndex]?.wrongAnswer || gameRounds()[roundIndex]?.noAnswerSelected) {
                <i class="fa fa-frown"></i>
                }
                @if (gameRounds()[roundIndex].answerSkipped) {
                <i class="fa fa-step-forward"></i>
                }
                @if (!gameRounds()[roundIndex]?.hasAnswer) {
                <span>
                  {{gameRounds()[roundIndex]?.roundNumber}}
                </span>
                }
              </div>
            </div>
          </div>
          <div>
            <a class="arrow right" [class.disabled]="roundIndex === roundsNumber() - 1 || isWheelSpinning" href="#"
               (click)="scrollRightMobile($event)" title="Click to shift the list of progress steps to the right"></a>
          </div>
        </div>
        }
      </div>
    </div>
    <p class="title">{{i18n.str('challengeu.topic_progress','Progress')()}}: {{currentRound?.roundNumber - 1}} /
      {{gameRounds().length}}</p>
  </div>
  <div class="round-topic" [class.selecting-topic]="isWheelSpinning">
    @if (topicSelected && !isWheelSpinning) {
    <img [src]="topicIconUrl(topicSelected)" [alt]="topicSelected.name">
    <p class="name">{{ topicSelected.name }}</p>
    }
    @if (!topicSelected && !isWheelSpinning && gameEngineService.selectedTopic) {
      <img [src]="topicIconUrl(gameEngineService.selectedTopic)" [alt]="gameEngineService.selectedTopic.name">
      <p class="name">{{ gameEngineService.selectedTopic.name }}</p>
    }
    @if (isWheelSpinning) {
    <p class="name">{{i18n.str('challengeu.topic_selecting_topic','Selecting topic...')()}}</p>
    }
  </div>
  <div class="wheel">
    <div id="wrapper">
      <div id="wheel">
        <div id="inner-wheel" #wheel>
          @for (item of topics; track item; let i = $index) {
          <div (click)="newRandomSpin($event)" class="sec" [class.disabled]="disabledTopics.includes(item.id)">
            <img [src]="topicIconUrl(item)" [alt]="item.name" [title]="item.name">
          </div>
          }
        </div>
      </div>
      <a href="#" id="spin" [class.beat]="canSpin()" [class.disabled]="!canSpin()" #outerSpin
         (click)="newRandomSpin($event)">
        <span id="inner-spin">{{i18n.str('challengeu.topic_spin','SPIN')()}}</span>
      </a>
      @for (i of [].constructor(5); track $index) {
      <div #lightbulb class="bulb off">
        <div class="light"></div>
        <div class="bottom"></div>
      </div>
      }
    </div>
    <ul class="jeopardy-jetons-grid">
      @for (item of difficultyLevels; track item) {
      <li>
        <a class="chip" href="#" (click)="selectToken($event, item)"
           [class.selected]="selectedToken?.points === item.points"
           [class.disabled]="disabledTokens.includes(item.points) || !topicSelected">
          <img [src]="disabledTokens.includes(item.points) ? item.disabledPath : item.imagePath"
               alt="{{i18n.str('challengeu.topic_click_choose','Click to choose a question worth')()}}  {{item.points}} {{i18n.str('challengeu.topic_points','points')()}}" />
        </a>
      </li>
      }
    </ul>
  </div>
  <div class="start-round">
    <p class="menu-item round-neon music-off" [class.active]="!musicOff()">
      <a href="#" (click)="doMuteMusic($event)" title="{{ i18n.str('challengeu.main_music_off', 'Music off')() }}">
        <img src="assets/app-branding/img/icons/Icons-music-small.png" height="150"
             alt="{{ i18n.str('challengeu.main_music_off', 'Music off')() }}" />
      </a>
    </p>
    <p class="menu-item round-neon sounds-off" [class.active]="!soundsOff()">
      <a href="#" (click)="setSoundsFX($event)" title="{{ i18n.str('challengeu.main_sounds_off', 'Sounds off')() }}">
        <img src="assets/app-branding/img/icons/Icons-sounds-small.png" height="150"
             alt="{{ i18n.str('challengeu.main_sounds_off', 'Sounds off')() }}" />
      </a>
    </p>
  </div>
</div>
}
